import Styled from 'styled-components';

export const BuyBundlesWrapper = Styled.div`
  .buy-bundles-header {
    margin-bottom: 24px;

    h1 {
      font-weight: 700;
      font-size: 24px;
      color: #111827;
      margin-bottom: 4px;
    }

    p {
      font-weight: 400;
      font-size: 14px;
      color: #6b7280;
      margin-bottom: 0;
    }
  }

  .buy-bundles-categories {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  @media only screen and (max-width: 767px) {
    .buy-bundles-header {
      margin-bottom: 16px;

      h1 {
        font-size: 20px;
      }
    }

    .buy-bundles-categories {
      gap: 24px;
    }
  }

  // The shared page wrapper (Main) drops to padding: 4px 0 below 480px — effectively no
  // horizontal padding at all — so restore reasonable screen padding here instead of touching
  // that app-wide component.
  @media only screen and (max-width: 480px) {
    padding: 12px 16px;
  }
`;

export const CategorySectionStyled = Styled.div`
  .category-section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    svg {
      flex-shrink: 0;
    }

    .category-section-text {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    h2 {
      font-weight: 700;
      font-size: 17px;
      line-height: 25.5px;
      color: #111111;
      margin-bottom: 0;
    }

    p {
      font-weight: 400;
      font-size: 13px;
      line-height: 19.5px;
      color: #6b7280;
      margin-bottom: 0;
    }
  }

  .category-section-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  @media only screen and (max-width: 767px) {
    .category-section-header {
      align-items: flex-start;
      gap: 8px;
      margin-bottom: 12px;

      svg {
        width: 36px;
        height: 36px;
      }
    }

    .category-section-cards {
      gap: 12px;
    }
  }
`;

export const BundleCardStyled = Styled.div`
  width: 250px;
  height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  background: #ffffff;

  @media only screen and (max-width: 767px) {
    width: 100%;
    height: auto;
    min-height: 200px;
  }

  .bundle-card-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .bundle-card-name {
    font-weight: 600;
    font-size: 14px;
    line-height: 145%;
    color: #111111;
  }

  .bundle-card-subheading {
    font-weight: 400;
    font-size: 12px;
    line-height: 145%;
    color: #1f1f1f;
  }

  .bundle-card-strike-wrap {
    position: relative;
    display: inline-block;
    margin-top: 21px;
    font-weight: 400;
    font-size: 12px;
    color: #767676;
  }

  .bundle-card-strike-line {
    position: absolute;
    inset-inline-start: 0;
    top: 50%;
    width: 58.9464px;
    height: 0;
    border-top: 1px solid #e83a3a;
    transform: translateY(-50%) rotate(10.28deg);
  }

  .bundle-card-price-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 5px;
  }

  .bundle-card-price {
    font-weight: 700;
    font-size: 22px;
    line-height: 145%;
    color: #111111;
  }

  .bundle-card-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 21px;
    border-radius: 4px;
    padding: 2px 12px;
    background: #ecf5f2;
    color: #00a651;
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;
  }

  .bundle-card-per-credit {
    margin-top: 5px;
    font-weight: 400;
    font-size: 12px;
    line-height: 145%;
    color: #9ca3af;
  }

  .bundle-card-button {
    width: 100%;
    height: 38px;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    background: #fff;
    padding: 8px 0;
    font-weight: 600;
    font-size: 14px;
    color: #374151;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }

    &.bundle-card-button--remove {
      background: #fff2f0;
      border: none;
      color: #ff615c;
    }
  }
`;

export const BundleOrderSummaryStyled = Styled.div`
  .bundle-summary-title {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 16px;
  }

  .bundle-summary-line {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;

    &:not(:last-child) {
      margin-bottom: 12px;
    }

    .bundle-summary-line-name {
      font-weight: 500;
      font-size: 14px;
      color: ${({ theme }) => theme['dark-color']};
    }

    .bundle-summary-line-quantity {
      font-weight: 700;
      font-size: 14px;
    }

    .bundle-summary-line-price {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 500;
      font-size: 14px;
      white-space: nowrap;
    }

    button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
    }
  }

  .bundle-summary-totals {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bundle-summary-total-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: ${({ theme }) => theme['gray-color']};

    &.bundle-summary-total-row--grand {
      font-size: 16px;
      font-weight: 700;
      color: ${({ theme }) => theme['dark-color']};
    }
  }
`;
